function ForwardToInbox({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.5 0.5H2.5C1.4 0.5 0.5 1.4 0.5 2.5V14.5C0.5 15.6 1.4 16.5 2.5 16.5H11.5V14.5H2.5V4.5L10.5 9.5L18.5 4.5V9.5H20.5V2.5C20.5 1.4 19.6 0.5 18.5 0.5ZM10.5 7.5L2.5 2.5H18.5L10.5 7.5ZM17.5 11.5L21.5 15.5L17.5 19.5V16.5H13.5V14.5H17.5V11.5Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default ForwardToInbox;
